#import "../../../../../../../../common/graphql/EntityUserMessageFields.graphql"
query TransactionSigningMessage(
  $id: UUID!
  $first: Int
  $after: Cursor
  $filter: UserMessageFilter
) {
  invoice(id: $id) {
    id
    userMessagesByEntityId(
      first: $first
      after: $after
      orderBy: _CREATED_DATE_DESC
      filter: $filter
    ) {
      nodes {
        ...EntityUserMessageFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
